import { useEffect } from 'react';

function useTokenRemoval() {
  useEffect(() => {
    const handleAuthStorageRemoval = (e) => {
      // Listen for Auth0 token removal
      if (e.key?.startsWith('@@auth0spajs@@') && e.oldValue && !e.newValue) {
        window.location.pathname = '/';
      }
    };
    window.addEventListener('storage', handleAuthStorageRemoval);
    return () => window.removeEventListener('storage', handleAuthStorageRemoval);
  }, []);
}

export default useTokenRemoval;
